export default "__VITE_ASSET__DSdVrssA__"